import { render, staticRenderFns } from "./SurveyQuestionDialog.vue?vue&type=template&id=80655442"
import script from "./SurveyQuestionDialog.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestionDialog.vue?vue&type=style&index=0&id=80655442&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports